import {
  DISCOUNT_COUPON,
  FINANCIAL_MANAGMENT,
  INVOICE_BILLING,
  MANAGE_ACTION,
  PAYMENT_IMPORT,
  READ_ACTION,
} from "@/constants/resources";

import * as types from "@/constants/financial_management_types";

const fixedFinancialRouteMeta = { fixedFinancialMenuRole: true };

export default [
  {
    path: "/contas/pagas",
    name: "financial-management-payables-paid",
    component: () =>
      import("@/modules/financial_management/views/FinancialManagement.vue"),
    meta: {
      resource: FINANCIAL_MANAGMENT,
      action: READ_ACTION,
      ...fixedFinancialRouteMeta,
    },
    props: {
      type: types.PAID,
    },
  },
  {
    path: "/contas/previstas",
    name: "financial-management-payables-expected",
    component: () =>
      import("@/modules/financial_management/views/FinancialManagement.vue"),
    meta: {
      resource: FINANCIAL_MANAGMENT,
      action: READ_ACTION,
      ...fixedFinancialRouteMeta,
    },
    props: {
      type: types.EXPECTED,
    },
  },
  {
    path: "/contas/faturamento",
    name: "financial-managment-invoices",
    component: () =>
      import("@/modules/financial_management/views/InvoiceHistory.vue"),
    meta: {
      resource: INVOICE_BILLING,
      action: MANAGE_ACTION,
      ...fixedFinancialRouteMeta,
      pageTitle: "Faturamento",
    },
  },
  {
    path: "/contas/:year?/:month?",
    name: "financial-management-payables",
    component: () =>
      import("@/modules/financial_management/views/FinancialManagement.vue"),
    meta: {
      resource: FINANCIAL_MANAGMENT,
      action: READ_ACTION,
      ...fixedFinancialRouteMeta,
    },
    props: {
      type: types.PAYABLES,
    },
  },
  {
    path: "/pagamento/importador",
    name: "payment-importer",
    component: () =>
      import("@/modules/financial_management/views/ImportPayments.vue"),
    meta: {
      resource: PAYMENT_IMPORT,
      action: READ_ACTION,
      ...fixedFinancialRouteMeta,
      pageTitle: "Importação de receitas",
    },
    props: {
      type: types.PAYABLES,
    },
  },
  {
    path: "/cupons",
    name: "discount-coupons",
    component: () =>
      import("@/modules/discount_coupon/views/DiscountCouponsList.vue"),
    meta: {
      resource: DISCOUNT_COUPON,
      action: READ_ACTION,
      ...fixedFinancialRouteMeta,
      pageTitle: "Cupons de desconto",
    },
  },
  {
    path: "/pagamentos/recebidos",
    name: "contract-payments",
    component: () =>
      import(
        "@/modules/financial_management/views/FinancialContractPaymentsList.vue"
      ),
    meta: {
      resource: FINANCIAL_MANAGMENT,
      action: READ_ACTION,
      ...fixedFinancialRouteMeta,
      pageTitle: "Pagamentos recebidos",
    },
  },
  {
    path: "/pagamento/importador/detalhes/:year/:month",
    name: "payment-import-details",
    component: () =>
      import("@/modules/financial_management/views/ImportPaymentsDetails.vue"),
    meta: {
      resource: PAYMENT_IMPORT,
      action: READ_ACTION,
      ...fixedFinancialRouteMeta,
      pageTitle: "Detalhes da importação",
    },
  },
  {
    path: "/pagamento/empresa",
    name: "payment-company",
    component: () =>
      import(
        "@/modules/financial_management/views/CompanyCommissionHistory.vue"
      ),
    meta: {
      resource: FINANCIAL_MANAGMENT,
      action: READ_ACTION,
      pageTitle: "Meus pagamentos",
      navActiveLink: "withdrawal-list",
    },
  },
];
